import React from 'react';
import * as serviceWorker from './serviceWorker';
import moment from "moment";
import "moment/min/locales.min";
import App from "./App/App";
import store from "./redux";
import Provider from "react-redux/es/components/Provider";
import {Router} from "react-router-dom";
import history from "./utility/history";
import reportWebVitals from "./reportWebVitals";
import {SocketProvider} from "socket.io-react-hooks-advanced";
import {createRoot} from "react-dom/client";
import {Env} from "./config";

window.moment = moment;

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <Router history={history}>
            <SocketProvider
                url={Env.REACT_APP_WEB_SOCKET}
                extraHeaders={{platform: "mt_website"}}
                maxRetries={5}>
                <React.StrictMode>
                    <App/>
                </React.StrictMode>
            </SocketProvider>
        </Router>
    </Provider>
);

serviceWorker.register();
reportWebVitals();
